module.exports = "/_next/static/resources/wfw-wide-64537e352c0a8332461f8f72439ff773.webp";